import Layout from "../../../components/student/Layout/layout";
import StudentLiveVideos from "../../../containers/student/live-videos";

const StudentLiveVideosPage = () => {
  return (
    <Layout>
      <StudentLiveVideos />
    </Layout>
  );
};

export default StudentLiveVideosPage; 